/** @jsx jsx */

/** @jsxFrag React.Fragment */
import { css, jsx } from '@emotion/react';

import { Typography2 } from '@coursera/cds-core';

import _t from 'i18n!nls/unified-common';

const styles = {
  noResultsFound: css`
    margin-top: var(--cds-spacing-800);
    margin-bottom: var(--cds-spacing-400);
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;

    p {
      margin-top: var(--cds-spacing-100);
    }
  `,
};

type Props = {
  filterName: string;
};

const EmptyFilteredCollectionMessage = (props: Props) => {
  const { filterName } = props;
  return (
    <div css={styles.noResultsFound}>
      <Typography2 variant="subtitleLarge" component="h3">
        {_t('No results found for "#{filterName}"', {
          filterName,
        })}
      </Typography2>
      <Typography2 variant="bodyPrimary" component="p">
        {_t('Try changing your filters')}
      </Typography2>
    </div>
  );
};

export default EmptyFilteredCollectionMessage;
